import Cookies from 'js-cookie'

class PermissionsHelper {
  constructor() {
    throw new Error('Cannot construct singleton')
  }

  static set mapsPermitted(value) {
    Cookies.set('roserGMEnabled' , value, { expires: 30 })
  }

  static get mapsPermitted() {
    return Cookies.get('roserGMEnabled')
  }

}

export default PermissionsHelper
